import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AppContext } from '../App';
import { Card, CardContent } from '@/components/ui/card';

export default function Stores() {
  const { t, i18n } = useTranslation();
  const { API } = useContext(AppContext);
  const [shops, setShops] = useState([]);

  useEffect(() => {
    fetchShops();
  }, []);

  const fetchShops = async () => {
    try {
      const response = await axios.get(`${API}/shops`);
      setShops(response.data);
    } catch (error) {
      console.error('Error fetching shops:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5]" data-testid="stores-page">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold mb-8 text-[#0A2540]" data-testid="stores-title">
          {t('nav.stores')}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {shops.map(shop => (
            <Link key={shop.id} to={`/shop?shop=${shop.id}`} data-testid={`shop-${shop.id}`}>
              <Card className="hover:shadow-xl transition-shadow h-full">
                <CardContent className="p-6">
                  {shop.logo && (
                    <img 
                      src={shop.logo} 
                      alt={shop.name}
                      className="w-full h-32 object-contain mb-4"
                    />
                  )}
                  <h3 className="font-bold text-xl mb-2">{shop.name}</h3>
                  <p className="text-gray-600 text-sm">
                    {i18n.language === 'fr' ? shop.description_fr : shop.description_en}
                  </p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        {shops.length === 0 && (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">{t('loading')}</p>
          </div>
        )}
      </div>
    </div>
  );
}